import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "app-page-header__column app-page-header__column--tools" }

import DotsSvg from '@/assets/dots.svg';

// Components
import VSearchField from '../components/VSearchField.vue';
import VFilterPopup from '../components/VFilterPopup.vue';
import VPage from '../components/VPage.vue';
import VPageHeader from '../components/VPageHeader.vue';
import VPageContent from '../components/VPageContent.vue';
import VButtonDropdown from '../components/VButtonDropdown.vue';

// Widgets
import NumericsWidget from '../widgets/NumericsWidget.vue';

// Other
import { useI18n } from 'vue-i18n';
import { onMounted } from 'vue';
import { IDropdownOption } from '@/core/Values/IDropdownOption';
import { setPageTitle } from '@/utils/document-utils';
import { useNumericFilters } from '@/mixins/NumericApi';


export default /*@__PURE__*/_defineComponent({
  __name: 'NumericsPage',
  setup(__props) {

// Svg
const { t } = useI18n();
const { filters, searchString, filterOptionsNamed, customFilters } = useNumericFilters('numerics.list', {}, {});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const filterOptions = Object.values(filterOptionsNamed);

let pageTitle = t('numerics-list');
let pageActions: IDropdownOption[] = [];

onMounted(() => {
    setPageTitle(pageTitle);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VPage, null, {
    default: _withCtx(() => [
      _createVNode(VPageHeader, {
        "show-third-block": "",
        title: _unref(pageTitle)
      }, {
        second: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(VFilterPopup, {
              modelValue: _unref(customFilters),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(customFilters) ? (customFilters).value = $event : null)),
              class: "prevent-close",
              options: _unref(filterOptions)
            }, null, 8, ["modelValue", "options"]),
            (_unref(pageActions).length)
              ? (_openBlock(), _createBlock(VButtonDropdown, {
                  key: 0,
                  class: "prevent-close",
                  options: _unref(pageActions),
                  placement: "left-start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DotsSvg), { class: "rotate-90" })
                  ]),
                  _: 1
                }, 8, ["options"]))
              : _createCommentVNode("", true),
            _createVNode(VSearchField, {
              modelValue: _unref(searchString),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(searchString) ? (searchString).value = $event : null)),
              class: "prevent-close",
              "debounce-mode": ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(VPageContent, { vertical: "" }, {
        default: _withCtx(() => [
          _createVNode(NumericsWidget, {
            filters: _unref(filters),
            "widget-page": "",
            "widget-secondary": ""
          }, null, 8, ["filters"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})